// Anchor → "Describe the target": a natural-language brief with @-references
// and inline target definition. LOCKED during Pilot — visible as a preview,
// not yet editable. Ported from the Claude Design prototype (anchor-target.jsx).

import { Icon } from "@/components/Icon/Icon";
import { PilotBarrier } from "@/components/PilotLock";

export function DescribeMode() {
  return (
    <div>
      <div className="hstack" style={{ gap: 8, marginBottom: 12, alignItems: "center" }}>
        <span className="label" style={{ margin: 0 }}>
          Describe the target in your own words
        </span>
      </div>

      <PilotBarrier compact cardWidth={300} blur={1.0} dim={0.97} scrim={7} scrimColor="#8b8d86">
        <div className="vstack gap-3" style={{ pointerEvents: "none" }}>
          {/* Natural-language brief with @-references */}
          <div className="vstack gap-2">
            <div
              style={{
                border: "1px solid var(--line)",
                borderRadius: 8,
                background: "var(--bg)",
                padding: "12px 14px",
                minHeight: 120,
                fontSize: 13,
                color: "var(--ink-3)",
                lineHeight: 1.6,
              }}
            >
              Make it brighter and jammier than{" "}
              <span
                style={{
                  background: "var(--accent-soft)",
                  color: "var(--accent-ink)",
                  border: "1px solid var(--accent-line)",
                  borderRadius: 4,
                  padding: "1px 6px",
                  fontWeight: 500,
                }}
              >
                @Gariguette Strawberry Base v3
              </span>
              , with a soft dairy cream tail — a little closer to real{" "}
              <span
                style={{
                  background: "var(--accent-soft)",
                  color: "var(--accent-ink)",
                  border: "1px solid var(--accent-line)",
                  borderRadius: 4,
                  padding: "1px 6px",
                  fontWeight: 500,
                }}
              >
                @white peach pulp
              </span>{" "}
              than the new target I defined below.
            </div>
            <div
              className="hstack"
              style={{ gap: 6, fontSize: 11, color: "var(--ink-4)", alignItems: "center" }}
            >
              <Icon name="info" size={11} />
              <span>
                Type{" "}
                <span className="mono" style={{ color: "var(--ink-3)" }}>
                  @
                </span>{" "}
                to reference your flavors and substance library inline.
              </span>
            </div>
          </div>

          {/* Inline target definition — define new from chromatograms / tabular,
              then reference it from the text above. */}
          <div
            style={{
              border: "1px dashed var(--line-strong)",
              borderRadius: 8,
              padding: 14,
              background: "var(--bg-sunk)",
            }}
          >
            <div className="hstack" style={{ gap: 8, marginBottom: 10, alignItems: "center" }}>
              <Icon name="plus" size={12} />
              <span style={{ fontSize: 12, fontWeight: 500 }}>Define a new target to reference</span>
            </div>
            <div className="hstack" style={{ gap: 8, flexWrap: "wrap" }}>
              <span className="chip">
                <Icon name="molecule" size={10} />
                From chromatograms
              </span>
              <span className="chip">
                <Icon name="table" size={10} />
                From tabular data
              </span>
            </div>
          </div>
        </div>
      </PilotBarrier>
    </div>
  );
}
